import HttpClient from '../api/api';
import User from './user';
import { RegisterOutcome } from './AuthContext';

export interface LoginResponse {
  user: User;
}

export type DealType = 'CPA' | 'REV_SHARE' | 'HYBRID';

export interface RegisterRequestAffiliate {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  phoneNumber: string;
  skype: string;
  website: string;
  password: string;
  confirmPassword: string;
  estimatedMonthlyFtdsRange: string;
  proposedDealType: DealType;
  message: string;
  referralCode: string;
  trafficSourcesMethodList: string[];
  trafficSourcesGeoList: string[];
}

export interface RegisterRequest {
  affiliate: RegisterRequestAffiliate;
  gRecaptchaResponse: string;
}

class AuthApi extends HttpClient {
  public constructor() {
    super();
  }

  async login({ email, password }: { email: string, password: string }): Promise<LoginResponse> {
    const data = {
      username: email,
      password,
    };
    return this.instance.post('/api/admin/login', data, { headers: { username: email, password } });
  }

  async logout() {
    return this.instance.post('/api/logout' );
  }

  async register(request: RegisterRequest): Promise<RegisterOutcome> {
    return this.instance.post('/api/register', request );
  }

  async me(): Promise<User> {
    return this.doGet('/api/auth/user-info')
      .then((data: any) => data);
  }

  async getAccessToAffiliate(affiliateId: number): Promise<string> {
    return this.doGet(`/api/v3/admin/users/${affiliateId}/ott`);
  }
}

export const authApi = new AuthApi();
